import { Badge } from '@/shared/components/shadcn/badge';
import { cn } from '@/shared/utils';

type Props = {
  count: number;
  label: string;
};

export function CampaignCreatorImportPreview({ count, label }: Props) {
  return (
    <div className="flex items-center gap-2">
      <div className="text-foreground text-sm font-semibold">{label}</div>
      <Badge
        variant={count === 0 ? 'secondary' : undefined}
        className={cn(
          'rounded-full px-2.5 py-1 text-xs font-medium',
          count > 0 && 'bg-primary text-primary-foreground hover:bg-primary border-transparent',
        )}
      >
        {count} creator{count === 1 ? '' : 's'}
      </Badge>
    </div>
  );
}
